export const handleKeyValuePairOfErrorString = (errors) => {
  let errorMessage = '';
  errors.forEach((error) => {
    let errorMsg = error.split(':')[1];
    errorMessage += `${errorMsg}\n`;
  });
  if (errorMessage.length === 0) {
    errorMessage =
      'Something went wrong. Please try again later or Contact support@kula.ai';
  }
  return errorMessage;
};
